/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {WorkService} from '../../../../domain/model/work/history/work.service';
import {Router} from '@angular/router';
import {MilitaryExperienceService} from '../../../../domain/model/work/military/military-experience.service';
import {merge} from 'rxjs/observable/merge';
import {ScreensManagerDeps, ScreensManager} from '../../../../components/sections/service/screen-manager.class';

@Injectable()
export class WorkObservationsScreensManager extends ScreensManager {

    private show: boolean;

    screenChange$: Observable<boolean>;

    constructor(smgm: ScreensManagerDeps,
                private readonly _router: Router,
                private readonly _workService: WorkService,
                private readonly _militaryExperienceService: MilitaryExperienceService) {
        super(smgm);

        merge(this._workService.changes$, this._militaryExperienceService.changes$)
            .switchMap(() => this.refresh()).subscribe(() => {});
    }

    hasPreviousScreen(): boolean {
        return false;
    }

    hasNextScreen(): boolean {
        return false;
    }

    navigateToPreviousScreen(): Observable<boolean> { return Observable.of(true); }

    navigateToNextScreen(): Observable<boolean> { return Observable.of(true); }

    navigateToFirstScreen(): Observable<boolean> {
        return this._navigate(1);
    }

    navigateToLastScreen(): Observable<boolean> {
        return this._navigate(222);
    }

    private _navigate(index: number): Observable<boolean> {
        return Observable.fromPromise(this._router.navigateByUrl(this._pathFromRootUsing({index: index})));
    }

    protected _doRefresh(): Observable<any> {
        return this._workService.doHistoryGapsExist().do(value => this.show = value);
    }

    skip(): boolean {
        return !this.show;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/steps/observations/work-observations-screens-manager.service.ts